import React from 'react'
import { Button, Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import AddIcon from '@mui/icons-material/Add'
import { useTranslation } from 'react-i18next'

interface IAddNewButtonProps {
  text: string
  handleAddNew?: () => void
}

const ButtonCustom = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '8px 22px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: '#3F51B5',
  borderColor: '#3F51B5',
  fontFamily: 'Roboto',
  height: '40px',
  '&:hover': {
    backgroundColor: '#3F51B5',
    borderColor: '#3F51B5',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#3F51B5',
    borderColor: '#3F51B5',
  },
})

// eslint-disable-next-line react/prop-types
export const AddNewButton: React.VFC<IAddNewButtonProps> = ({
  handleAddNew,
  text,
}): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Box display={'flex'} justifyContent={'flex-end'}>
      <Button
        variant="contained"
        size="medium"
        startIcon={<AddIcon sx={{ fontSize: 14 }} />}
        onClick={handleAddNew}
        sx={{ fontSize: '14px', height: '40px' }}
      >
        {t(text)}
      </Button>
    </Box>
  )
}
